<template>
	<button :id="buttonId"
		:form="form"
		type="submit"
		:class="`btn btn-primary no-disabler ${additionalClass}`"
		:disabled="disabled"
		@click="$emit('click', $event)">
		<i :class="{
			'fa': true,
			[iconClass]: !isLoading,
			'fa-circle-o-notch fa-spin': isLoading,
		}" />
		<span>{{ label }}</span>
	</button>
</template>

<script>
export default {
	computed: {
		buttonId() {
			return this.form 
				? `${this.form}-${this.id}`
				: this.id
		}
	},
	props: {
		form: {
			type: String,
			required: false,
			default: null,
		},
		iconClass: {
			type: String,
			required: false,
			default: 'fa-floppy-o',
		},
		id: {
			type: String,
			required: false,
			default: 'submit-btn',
		},
		isLoading: {
			type: Boolean,
			required: false,
			default: false,
		},
		label: {
			type: String,
			required: false,
			default: 'Simpan',
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		additionalClass: {
			type: String,
			required: false,
			default: null,
		},
	},
}
</script>
